const COMPONENT_NAME = "QuantitySelector";
const IN_CART_LABEL = "in cart";
const DEFAULT_INCREMENT_ARIA_LABEL = "Increase Quantity";
const DEFAULT_DECREMENT_ARIA_LABEL = "Decrease Quantity";
const DEFAULT_INPUT_ARIA_LABEL = "Quantity";
const DEFAULT_REMOVE_IN_CART_LABEL = "Remove from Cart";
const ADD_TO_CART_LABEL = "Add to cart";
const QUANTITY_LABEL = "Quantity";
const EMPTY_CART_VALUE = 0;
const DEFAULT_MIN_ERROR_MSG = "Quantity must be {minValue} or more to add to cart.";
const DEFAULT_MAX_ERROR_MSG = "Quantity cannot exceed {maxValue}.";
const ACTION_TYPES = {
  INCREMENT: "increment",
  ADD: "add",
  SUBMIT: "submit",
  DECREMENT: "decrement",
  CHANGE: "change",
  BLUR: "blur",
  SHOW_ADD_TO_CART: "showAddToCart",
  SET_CURRENT_VALUE: "setCurrentValue",
  SET_CUSTOM_ERROR: "setCutomError"
};
const DEFAULT_ERROR_STATE = { errorStatus: false, errorMsg: "" };
export {
  ACTION_TYPES,
  ADD_TO_CART_LABEL,
  COMPONENT_NAME,
  DEFAULT_DECREMENT_ARIA_LABEL,
  DEFAULT_ERROR_STATE,
  DEFAULT_INCREMENT_ARIA_LABEL,
  DEFAULT_INPUT_ARIA_LABEL,
  DEFAULT_MAX_ERROR_MSG,
  DEFAULT_MIN_ERROR_MSG,
  DEFAULT_REMOVE_IN_CART_LABEL,
  EMPTY_CART_VALUE,
  IN_CART_LABEL,
  QUANTITY_LABEL
};
